import { render, staticRenderFns } from "./myServices.vue?vue&type=template&id=3d0f6f37&scoped=true"
import script from "./myServices.vue?vue&type=script&lang=js"
export * from "./myServices.vue?vue&type=script&lang=js"
import style0 from "./myServices.vue?vue&type=style&index=0&id=3d0f6f37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0f6f37",
  null
  
)

export default component.exports